export enum FileTypes {
  APPLICATION_FILES = 'APPLICATION_FILES',
  MEDIA_FILES = 'ALLOWED_MEDIA_TYPES',
  ALL_INVESTIGATION_FILES = 'ALL_INVESTIGATION_FILES',
  ALLOWED_MEDIA_TYPES = 'ALLOWED_MEDIA_TYPES'
}
